import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import TrendingProducts from 'src/components/Category/CategoryComman/TrendingProducts'
import FindYourStyle from '../WomanPageModal/FindYourStyle'
import FashionEnthusiasts from '../WomanPageModal/FashionEnthusiasts'
import FashionGroups from '../WomanPageModal/FashionGroups'
import TrendingStore from '../WomanPageModal/TrendingStore'
import { useRouter } from 'next/router'
import { useAppDispatch } from 'src/store/store'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { manageStyleDetail } from 'src/store/slices/manageCategoryDetail'
import WomenCategoryModalMain from './WomenCategoryModalMain'
import { log } from 'console'
import SubCategoryFindYourStyle from '../WomanPageModal/SubCategoryFindYourStyle'

export default function WomenPageModal() {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const manageApplianceCategoryModal = useSelector((state: any) => state?.manageApplianceCategoryModal?.data)
  const menStyleDetailModal = useSelector((state: any) => state?.manageCategoryDetail?.data)

  useEffect(() => {
    if (router?.query?.category) {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenShopByCategory',
          isOpen: true,
          id: router?.query?.category,
          for: 'women',
          type: null,
        }),
      )
    }
    if (router?.query?.type === 'trending') {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenNowTrending',
          isOpen: true,
          id: router?.query?.type,
          for: 'women',
          type: 'trending',
        }),
      )
    }
    if (router?.query?.type === 'style') {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenFindYourStyle',
          isOpen: true,
          id: router?.query?.style,
          for: 'women',
          type: 'style',
        }),
      )
      dispatch(manageStyleDetail({ modal: '', isOpen: false, id: 0 }))
    }
    if (router?.query?.type === 'club') {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenFashionClub',
          isOpen: true,
          id: router?.query?.type,
          for: 'women',
          type: 'club',
        }),
      )
    }
    if (router?.query?.type === 'store') {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenTrendingStore',
          isOpen: true,
          id: router?.query?.type,
          for: 'women',
          type: 'store',
        }),
      )
    }
    if (router?.query?.type === 'influencers') {
      dispatch(
        fetchApplianceCategory({
          modal: 'womenfashionInfluencers',
          isOpen: true,
          id: router?.query?.type,
          for: 'women',
          type: 'influencers',
        }),
      )
    }

    if (!(router?.query?.type || router?.query?.style || router?.query?.category || router?.query?.detail)) {
      dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
      dispatch(manageStyleDetail({ modal: '', isOpen: false, id: 0 }))
    } else {
    }

    if (router?.query?.type && router?.query?.detail) {
      dispatch(
        manageStyleDetail({
          modal: 'womenStyleDetails',
          isOpen: true,
          id: router?.query?.detail,
          for: 'women',
          type: 'styleDetail',
        }),
      )
    }
  }, [router])

  return (
    <React.Fragment>
      <div>
        <div>
          <div className={`overlay ${manageApplianceCategoryModal?.isOpen ? 'open' : ''}`} />
          <div
            className={`special-offer-modal ${manageApplianceCategoryModal?.isOpen ? 'open' : ''}`}
            style={{ width: '100%' }}
          >
            <div className="sidebar-modal-alignment borderRaduisNone" style={{ padding: 0, borderRadius: 0 }}>
              {manageApplianceCategoryModal?.modal === 'womenShopByCategory' && <WomenCategoryModalMain />}
              {manageApplianceCategoryModal?.modal === 'womenNowTrending' && <TrendingProducts />}
              {manageApplianceCategoryModal?.modal === 'womenFindYourStyle' && <FindYourStyle />}
              {manageApplianceCategoryModal?.modal === 'womenFashionClub' && <FashionGroups />}
              {manageApplianceCategoryModal?.modal === 'womenTrendingStore' && <TrendingStore />}
              {manageApplianceCategoryModal?.modal === 'womenfashionInfluencers' && <FashionEnthusiasts />}
            </div>
          </div>
        </div>
      </div>
      {/* <----------------------------------------------WOMEN_STYLE_DETAIL_START-------------------------------------------------------> */}
      <div>
        <div className={`overlay ${menStyleDetailModal?.isOpen ? 'open' : ''}`} />
        <div className={`special-offer-modal ${menStyleDetailModal?.isOpen ? 'open' : ''}`} style={{ width: '100%' }}>
          <div className="sidebar-modal-alignment borderRaduisNone" style={{ padding: 0, borderRadius: 0 }}>
            {menStyleDetailModal?.modal === 'womenStyleDetails' && <SubCategoryFindYourStyle />}
          </div>
        </div>
      </div>
      {/* <----------------------------------------------WOMEN_STYLE_DETAIL_END---------------------------------------------------------> */}
    </React.Fragment>
  )
}
